import React, { Component } from 'react';
import { connect } from "react-redux";
import NoCurrentChats from "../chat/NoCurrentChats";
import ChatDetail from "../chat/ChatDetail";



@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})

class ArchiveDetail extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        const { t } = this.props;


        if(typeof this.props.data.filter(cC=>cC.id==this.props.id)[0]!=="undefined") {
            return (
                <>
                    <ChatDetail  type="archive" chat={this.props.data.filter(cC=>cC.id==this.props.id)[0]} id={this.props.id}/>
                </>
            )
        }
        else if(typeof this.props.cdata.filter(cC=>cC.id==this.props.id)[0]!=="undefined") {
            return (
                <>
                    <ChatDetail  type="archive" chat={this.props.cdata.filter(cC=>cC.id==this.props.id)[0]} id={this.props.id}/>
                </>
            )
        }
        else{
            return (
                <NoCurrentChats description="To see the details of the chat you want, click on the chat"/>
            )
        }


    }
}

export default ArchiveDetail;
